'use client';

import { useRouter, usePathname, useParams, useSearchParams } from 'next/navigation';

// import { useRouter, usePathname, useParams, useSearchParams } from './router-history-api';

export { useRouter, usePathname, useParams, useSearchParams };

// export * from './use-router';
// export * from './use-search-params';
// export * from './use-params';
// export * from './use-pathname';
